module.exports = __webpack_public_path__ + "fonts/vizztons.0bd49b0.ttf";